import { QueryClient } from '@tanstack/react-query';
import { reactQueryConfig } from './containers/app/app.config';

/**
 * Module-level singleton QueryClient.
 *
 * Exported so non-React modules (e.g. `helpers/storage/storage.ts logout()`)
 * can call `queryClient.clear()` without a hook. The same instance is passed
 * to `<QueryClientProvider>` in `containers/app/app.tsx` so React components
 * read from the same cache.
 *
 * Test files and Storybook stories deliberately instantiate their own clients
 * for state isolation — do NOT replace those with this singleton.
 */
const queryClient = new QueryClient(reactQueryConfig);

export { queryClient };
